import React from 'react';

const FullCastModal = ({ isOpen, onClose, cast }) => {
  if (!isOpen) return null;

  const closeModal = (event) => {
    if (event.currentTarget === event.target) {
      onClose();
    }
  };

  return (
    <div className="modal-backdrop" onClick={closeModal}>
      <div className="modal-content">
        <div className="modal-header">
          <h2 className="modal-title">Full Cast</h2>
          <button onClick={onClose} className="close-button">&times;</button>
        </div>
        <div className="modal-body modal-body-scroll">
          <ul>
            {cast.map((actor, index) => (
              <li key={index}>{actor}</li>
            ))}
          </ul>
        </div>
        <div className="modal-footer">
          <button onClick={onClose} className="close-modal-button">Close</button>
        </div>
      </div>
    </div>
  );
};

export default FullCastModal; 